/*
 * @Author: v_smwang
 * @Date: 2020-08-01 15:23:49
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-13 09:45:49
 * @FilePath: \src\store\modules\personnelPortraitOverview.js
 * @Description: 描述
 * @Module: 模块路径
 */
const personnelPortraitOverview = {
  namespaced: true,
  state: {
    formData: {
      // 筛选条件
      start_time: '',
      end_time: '',
      production_line: '',
      task_type: '',
      task_label: '',
      outsourcer: '',
      platform: 0,
      time_type: '天',
    },
    activeTabName: 'zhizuo',
    inquireNum: 0,
    dropDownNum: 1,
  },

  mutations: {
    UPDATE_FORMDATA: (state, {
      fieldName,
      value,
    }) => {
      state.formData[fieldName] = value;
    },
    UPDATE_ACTIVETABNAME: (state, params) => {
      // 更新tab页，制作还是内检
      state.activeTabName = params;
    },
    // eslint-disable-next-line no-unused-vars
    UPDATE_INQRIRENUM: (state, params) => {
      // 点击查询次数
      state.inquireNum = state.inquireNum + 1;
    },
    UPDATE_SELECTEDROPDOWN: (state, params) => {
      // 更新下拉框
      state.dropDownNum = params;
    },
  },

  actions: {
  },
};

export default personnelPortraitOverview;
